import React, { Component } from "react"
import I18n from "../../utils/i18n.js"
import ReactDOM from "react-dom"

import AccommodationMixin from '../mixins/accommodation_mixin'
import Loading from './loading'

import createReactClass from 'create-react-class'
export default createReactClass({
  mixins: [AccommodationMixin],

  render() {
    switch (this.props.screenSize) {
      default:
        return <Loading />
      case 'mobile':
        return this.renderMobile()
      case 'desktop':
        return this.renderDesktop()
    }
  },

  renderDesktop() {
    let favorite_class = 'favorite-icon icon-heart-1';
    if (this.props.accommodation.favorited) { favorite_class += ' favorite-active'; }

    const price = this.object_price();
    const rating = this.object_rating();
    const last_minute = this.isLastMinute() ? <div className="last-minute-wrapper">LAST MINUTE</div> : undefined;

    return <div className="box box--horizontal">
      <a href={this.props.accommodation.path} className="box__inner" title={[this.props.accommodation.object_name, this.props.accommodation.city.name, this.props.accommodation.departement.name].join(" - ")}>
        <div className="box__cell">
          <div className="box__visual" style={{ backgroundImage: `url(${this.props.accommodation.image})` }}>
            <img src={this.props.accommodation.image} />
            <div className="box__overlay box__overlay--hover">
              <div className="box__overlay-wrapper">
                <div className="box__overlay-inner">
                  {last_minute}
                  <h3 className="box__title">{this.object_name(this.props.accommodation.object_name)}</h3>
                  <div className="box__subtitle">{this.props.accommodation.city.name}</div>
                  {
                    this.props.favoriting ?
                      <div className="favorite-wrapper">
                        <div onClick={this.favorite} className={favorite_class} ></div>
                      </div> : null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="box__cell box__body">
          <div className="accomodation__content">
            {price}
            {rating}
            <ul className="iconbar iconbar--accommodation">
              <li className="iconbar__item icon-persons" title={I18n.t('search.info.upto_people', {count: this.props.accommodation.max_persons})}>
                <div className="iconbar__count">{this.props.accommodation.max_persons}</div>
              </li>
              <li className="iconbar__item icon-room" title={I18n.t('search.info.rooms', {count: this.props.accommodation.rooms})}>
                <div className="iconbar__count">{this.props.accommodation.rooms}</div>
              </li>
              <li className="iconbar__item icon-persons_per_room" title={I18n.t('search.info.min_max_rooms', {count: this.props.accommodation.persons_per_room})}>
                <div className="iconbar__count">{this.props.accommodation.persons_per_room}</div>
              </li>
            </ul>
         </div>
        </div>
      </a>
    </div>;
  },

  renderMobile() {
    let favorite_class = 'favorite-icon icon-heart-1';
    if (this.props.accommodation.favorited) { favorite_class += ' favorite-active'; }

    const price = this.object_price();
    const last_minute = this.isLastMinute() ? <div className="box__circle box__circle--lastminute">Last minute</div> : undefined;

    const rooms = this.props.accommodation.house_type === 'studio' ?
      <li className="iconbar__item icon-room" title={I18n.t('search.info.studio')}><div className="iconbar__count">{I18n.t('search.info.studio')}</div></li>
    :
      <li className="iconbar__item icon-room" title={I18n.t('search.info.bedrooms', {count: this.props.accommodation.rooms})}><div className="iconbar__count">{this.props.accommodation.rooms}</div></li>;

    return <div className="box box--mobile">
      <a href={this.props.accommodation.path} className="box__inner" title={[this.props.accommodation.object_name, this.props.accommodation.city.name, this.props.accommodation.departement.name].join(" - ")}>
        <div className="box__cell">
          <div className="box__visual" style={{ backgroundImage: `url(${this.props.accommodation.image})` }}>
            <img src={this.props.accommodation.image} />
              <div className="box__overlay-wrapper">
                <div className="box__overlay-inner">
                  {
                    this.props.favoriting ?
                      <div className="favorite-wrapper">
                        <div onClick={this.favorite} className={favorite_class} ></div>
                      </div> : null
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="box__cell box--purple box--table">
          <div className="box__title">
            {last_minute}
            <h3>{this.object_name(this.props.accommodation.object_name)}</h3>
            <div className="box__subtitle">{this.props.accommodation.city.name}</div>
          </div>
          {price}
        </div>
      </a>
    </div>;
  }
});
